/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-closing-tag-location */
// LIBRARY
import React from 'react';
import { Row, Col, Typography } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';

import './patient_info.css';

// const colLayout = {
// 	xxl: { span: 12 },
// 	xl: { span: 12 },
// 	lg: { span: 12 },
// 	sm: { span: 24 },
// 	md: { span: 12 },
// 	xs: { span: 12 },
// };

class PatientInfo extends React.Component {
	computeAge = date => {
		const years = Math.floor(moment().diff(date, 'years', true));
		const age = years > 0 ? years : 0;

		return age;
	};

	render() {
		const { Text, Title } = Typography;

		return (
			<div className="patient-info-shared">
				<div className="info-container">
					<Title level={5} className="main-title">
						Personal Information
					</Title>
					<div className="info-content">
						<Text className="info-title">BIRTHDATE</Text>
						<Text className="info-item-text">{this.props.patientInfo.dateOfBirth}</Text>
					</div>
					<div className="info-content">
						<Text className="info-title">AGE</Text>
						<Text className="info-item-text">
							{this.computeAge(this.props.patientInfo.dateOfBirth)}
						</Text>
					</div>
					<div className="info-content">
						<Text className="info-title">GENDER</Text>
						<Col className="info-item-text">{this.props.patientInfo.sex}</Col>
					</div>
				</div>

				{/* Other Information */}
				<div className="info-container">
					<Title level={5} className="main-title">
						Other Information
					</Title>
					<div className="info-content">
						<Text className="info-title">HOSPITAL ID</Text>
						<Text className="info-item-text">{this.props.patientOtherInfo.hospitalID}</Text>
					</div>
					<div className="info-content">
						<Text className="info-title">PHYSICIAN</Text>
						<Text className="info-item-text">{this.props.patientOtherInfo.physician}</Text>
					</div>
					<div className="info-content">
						<Text className="info-title">WARD/ROOM</Text>
						<Text className="info-item-text">{this.props.patientOtherInfo.location}</Text>
					</div>
					<div className="info-content">
						<Text className="info-title">BED</Text>
						<Text className="info-item-text">{this.props.patientOtherInfo.bed}</Text>
					</div>
					<div className="info-content">
						<Text className="info-title">VISIT</Text>
						<Text className="info-item-text">{this.props.patientOtherInfo.visit}</Text>
					</div>
					<div className="info-content">
						<Text className="info-title">CHARGE SLIP</Text>
						<Text className="info-item-text">{this.props.patientOtherInfo.chargeSlip}</Text>
					</div>
					<div className="info-content">
						<Text className="info-title">RECEIPT</Text>
						<Text className="info-item-text">{this.props.patientOtherInfo.receipt}</Text>
					</div>
					<div className="info-content">
						<Text className="info-title">COMMENT</Text>
						<Text>{this.props.patientOtherInfo.comment}</Text>
					</div>
				</div>
			</div>
		);
	}
}

PatientInfo.propTypes = {
	patientInfo: PropTypes.object,
	patientOtherInfo: PropTypes.shape({
		hospitalID: PropTypes.string,
		physician: PropTypes.string,
		bed: PropTypes.string,
		visit: PropTypes.string,
		chargeSlip: PropTypes.string,
		receipt: PropTypes.string,
		comment: PropTypes.string,
		location: PropTypes.string,
	}),
};

PatientInfo.defaultProps = {
	patientInfo: {},
	patientOtherInfo: {
		hospitalID: '-',
		physician: '-',
		bed: '-',
		visit: '-',
		chargeSlip: '-',
		receipt: '-',
		comment: '-',
		location: '-',
	},
};

export default PatientInfo;
